import { render, staticRenderFns } from "./PopularsOverview.vue?vue&type=template&id=40394006&scoped=true&"
import script from "./PopularsOverview.vue?vue&type=script&lang=js&"
export * from "./PopularsOverview.vue?vue&type=script&lang=js&"
import style0 from "./PopularsOverview.vue?vue&type=style&index=0&id=40394006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40394006",
  null
  
)

export default component.exports